
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderTeacherShareCalculationDialog extends Serenity.EntityDialog<OrderTeacherShareCalculationRow, any> {
        protected getFormKey() { return OrderTeacherShareCalculationForm.formKey; }
        protected getIdProperty() { return OrderTeacherShareCalculationRow.idProperty; }
        protected getLocalTextPrefix() { return OrderTeacherShareCalculationRow.localTextPrefix; }
        protected getService() { return OrderTeacherShareCalculationService.baseUrl; }
        protected getDeletePermission() { return OrderTeacherShareCalculationRow.deletePermission; }
        protected getInsertPermission() { return OrderTeacherShareCalculationRow.insertPermission; }
        protected getUpdatePermission() { return OrderTeacherShareCalculationRow.updatePermission; }

        protected form = new OrderTeacherShareCalculationForm(this.idPrefix);

    }
}